module.exports = __webpack_public_path__ + "img/logo.70597ed0.png";